import Button from 'molecules/Button';
import Icon from 'molecules/Icon';

import type { HeaderProps } from '..';
import type { ButtonProps } from 'molecules/Button';
import type { FC } from 'react';

interface HeaderCtasProps {
  ctas: HeaderProps['ctas'];
  mobileMenuActive: boolean;
  hamburger: boolean;
  toggleMenu: () => void;
}

const HeaderCtas: FC<HeaderCtasProps> = ({ ctas, mobileMenuActive, hamburger, toggleMenu }) => (
  <div className="flex items-center gap-4">
    {ctas?.map(
      button =>
        button && (
          <Button
            key={button?.id}
            styles="!px-4 !py-2 !text-md !text-base xl:!text-lg xl:!px-6 xl:!py-4 xl:!text-lg"
            {...(button as ButtonProps)}
          />
        ),
    )}
    {hamburger && (
      <button type="button" className="flex lg:hidden" onClick={toggleMenu}>
        <Icon icon={mobileMenuActive ? 'x' : 'hamburger'} size={24} />
      </button>
    )}
  </div>
);

export default HeaderCtas;
